<template>
  <span>
    <v-dialog v-model="dialog" @keydown.esc="cancel" max-width="400" persistent scrollable>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Use o link para visualizar o formulário
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap justify-center align-center>
            <v-flex xs12>
              <v-tooltip top>
                <v-text-field append-icon="file_copy" slot="activator" readonly name="link" id="link" label="Link" :value="link" @click="copyLink" messages="Link usado para visualizar o formulário" @click:append="copyLink"/>
              <span>Clique para copiar</span>
            </v-tooltip>  
            </v-flex>
            <v-flex xs12 style="padding-top: 20px">
              <v-tooltip top>
                <v-textarea append-icon="file_copy" slot="activator" readonly name="embed" id="embed" label="Incorporar" rows="2" :value="embed" @click="copyEmbed" messages="Use o código acima em seu site para mostrar o formulário" @click:append="copyEmbed"/>
              <span>Clique para copiar</span>
            </v-tooltip> 
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" flat @click.native="cancel">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  export default {
    name: 'PShareForm',
    data: () => ({
      dialog: false,
      link: '',
      embed: ''
    }),
    methods: {
      openDialog (formId) {
        this.dialog = true
        this.link = `https://${window.location.hostname}/#/form_view/${btoa(formId)}`
        this.embed = `<iframe src="${this.link}" width="650" height="700"></iframe>`
      },
      copyLink () {
        var copyText = document.getElementById('link')
        /* Select the text field */
        copyText.select()
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999)
        /* Copy the text inside the text field */
        setTimeout(() => {
          document.execCommand('copy')
          this.$store.commit('snackbar/change_values', { text: `Link copiado para sua área de transferência!`, color: 'success', dialog: true })
        }, 200)
      },
      copyEmbed () {
        var copyText = document.getElementById('embed')
        /* Select the text field */
        copyText.select()
        /* For mobile devices */
        copyText.setSelectionRange(0, 99999)
        /* Copy the text inside the text field */
        setTimeout(() => {
          document.execCommand('copy')
          this.$store.commit('snackbar/change_values', { text: `Embed copiado para sua área de transferência!`, color: 'success', dialog: true })
        }, 200)
      },
      cancel () {
        this.dialog = false
      }
    },
    computed: {
      // link: function () {
      //   return `https://${window.location.hostname}/#/form_view/${btoa(formId)}`
      // },
      // embed: function () {
      //   return `https://${window.location.hostname}/#/form_view/${btoa(formId)}`
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PShareForm.vue